import { Container, Tab, Tabs, Box, Stack, Paper, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useWindowDimensions from "../../../hooks/windowDimensions";
import RexPlaylist from './RexPlaylist';
import SocialLinks from './SocialLinks';
import ZoomModal from './ZoomModal';
import StreamLinks from './StreamLinks';
import Events from './Events';

const EPK = ({ artist }) => {
  const { height, width } = useWindowDimensions();
  const [view, setView] = useState('epk')
  const [zoomModalOpen, setZoomModalOpen] = useState(null)
  const [zoomType, setZoomType] = useState(null)
  const [currentImg, setCurrentImg] = useState(artist?.pics?.length > 0 ? artist?.pics[0] : '')
  const [currentVid, setCurrentVid] = useState(artist?.vids?.length > 0 ? artist?.vids[0] : '')
  const [currentAlbum, setCurrentAlbum] = useState(artist?.albums?.length > 0 ? artist?.albums[0] : '')

  const handleImgBack = () => {
    const currentIndex = artist?.pics?.indexOf(currentImg)
    const picsLength = artist?.pics?.length
    const newIndex = (currentIndex - 1 + picsLength) % picsLength
    setCurrentImg(artist?.pics[newIndex])
  }

  const handleImgNext = () => {
    const currentIndex = artist?.pics?.indexOf(currentImg)
    const picsLength = artist?.pics?.length
    const newIndex = (currentIndex + 1) % picsLength
    setCurrentImg(artist?.pics[newIndex])
  }

  const handleVidBack = () => {
    const currentIndex = artist?.vids?.indexOf(currentVid)
    const vidsLength = artist?.vids?.length
    const newIndex = (currentIndex - 1 + vidsLength) % vidsLength
    setCurrentVid(artist?.vids[newIndex])
  }

  const handleVidNext = () => {
    const currentIndex = artist?.vids?.indexOf(currentVid)
    const vidsLength = artist?.vids?.length
    const newIndex = (currentIndex + 1) % vidsLength
    setCurrentVid(artist?.vids[newIndex])
  }
  const formattedBio = (bioText) => {
    // const paragraphs = bioText.split(/\n\s*\n/);
    const paragraphs = bioText.split('__');
    return paragraphs.map((p, i) => <p key={i}>&nbsp;&nbsp;{p}</p>);
    // return paragraphs[0]
  }
  useEffect(() => {

  }, [currentImg, currentVid, zoomType])
  return (
    <Container sx={{
      color: '#000', fontWeight: 'normal',
      width: '100%',
      padding: '0.5rem',
      // border:'1px solid green',

    }}>
      <Stack sx={{
        gap: '0.5rem', justifyContent: 'center',
        width: '100%',
        //  border:'1px solid yellow', 

      }}>
        <Stack sx={{
          gap: '0.5rem',
          //  border:'1px solid blue',
          justifyContent: 'center', width: '100%', margin: 'auto'
        }}>
          <Box sx={{
            // padding:'0.5rem',
            width: '95%',
            // height:'100%',minHight:'400px', 
            margin: 'auto',
            color: '#000', overflow: 'hidden',
            backgroundColor: '#FFF',
            border: '1px solid #000', borderRadius: '5px',
            display: 'flex', gap: '0.5rem',
            flexDirection: width <= 700 ? 'column' : 'row',
            padding: '1rem 0.5rem', font: 'Gilory,sans-serif',
            justifyContent: 'center'
          }}>

            {artist?.pics[0] && <Box component='img'
              src={artist?.pics[0]}
              sx={{
                borderRadius: '5px',

                border: '2px solid #000',
                width: width <= 600 ? '50%' : '50%', margin: 'auto',
                maxWidth: width <= 600 ? '300px' : '400px',
                cursor: 'pointer', boxShadow: 'inset 0px -5px 10px 5px rgba(0, 0, 0, 1),0px 0px 6px 2px rgba(0, 0, 0, 0.7)'
              }}
              onClick={(e) => {
                setCurrentImg(artist?.pics[0])
                setZoomType('img')
                setZoomModalOpen(true)
              }}
            ></Box>}

            <Box sx={{
              position: 'relative', display: 'flex', flexDirection: 'column', flexWrap: 'wrap',
              justifyContent: 'center', textAlign: 'left',
              width: width <= 600 ? '90%' : '90%', margin: 'auto', gap: '0.5rem'
            }}>

              <Box sx={{
                // position:'absolute',
                // left:'45%',
                //top:'0.5rem', 
                //transform: 'translate(-40%,0)',
                position: 'relative',
                margin: 'auto',
                backgroundColor: '#FFF',

              }}
              >
                <b style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                  {artist?.genre ? artist?.genre : ''}
                </b>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center', margin: 'auto'
                }}>
                  <SocialLinks artist={artist} size='lrg' sx={{ margin: 'auto' }} />
                </Box>
              </Box>
              {/* {artist?.bio} */}
              {/* {artist?.bio &&  */}
              <Stack style={{
                padding: '0.5rem', gap: '0.5rem',
                margin: 'auto', width: '70%',
                maxWidth: width <= 600 ? '300px' : '500px'
              }}>
                {formattedBio(artist?.bio?.toString())}
              </Stack>
              {/* } */}
              <Stack sx={{
                border: '1px solid #000', borderRadius: '5px',
                display: 'flex', gap: '0.5rem',
                margin: 'auto', width: '70%', flexWrap: 'wrap', padding: '0.5rem', minHeight: '150px',
                boxShadow: '0px 0px 5px 3px rgba(0, 0, 0, 0.5)'
              }}>
                <Box>

                  <b>
                    Members:
                  </b>
                </Box>
                <Box style={{ overflow: 'hidden', overflowY: 'scroll' }}>
                  {artist?.members?.length > 0 && artist?.members?.map((s, i) => {

                    return (
                      <Box sx={{
                        display: 'flex',
                        flexDirection: width >= 600 ? 'column' : 'row',
                        gap: '0.5rem',
                        margin: 'auto',
                        padding: '0.25rem',
                        width: '100%', justifyContent: 'center'
                      }}>
                        {/* <Box sx={{width: width >= 600? '50%': '100%', height:'auto', 
                            minWidth: width >= 600? '100px':'50px',
                              overflow:'hidden',alignSelf:'center',margin:'auto'}}> */}

                        {s?.pics?.length > 0 && <img src={s?.pics[0]}
                          style={{
                            width: width >= 600 ? '100px' : '50px', height: 'auto',
                            maxHeight: width >= 600 ? '100px' : '50px', borderRadius: '5px',
                            border: '1px solid #000',
                            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                            alignSelf: 'center', margin: 'auto'

                          }} />}
                        {/* </Box> */}
                        <Stack>

                          <span> {s?.name} ( {s?.actual_name} )</span>
                          <span style={{ fontSize: '0.8rem' }}>{s?.location?.city}, {s?.location?.state}</span>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'center', margin: 'auto'
                          }}>

                            <SocialLinks artist={s} size='sml' />
                          </Box>
                          <p style={{ padding: '0.5rem' }}>
                            {s?.bio && formattedBio(s?.bio)}
                          </p>
                        </Stack>
                      </Box>
                    )
                  })}
                </Box>
              </Stack>

            </Box>
          </Box>
          {/* <Paper> */}
          <Box sx={{
            position: 'relative', width: '100%',
            height: 'fit-content', margin: 'auto', alignSelf: 'center'
          }}>
            <RexPlaylist view='epk' />
          </Box>
        </Stack>

        <Container sx={{
          padding: '0.5rem', width: '100%', height: '100%', minHight: '400px',
          color: '#000', overflow: 'hidden',
          backgroundColor: '#FFF', border: '1px solid #000', borderRadius: '5px',
          justifyContent: 'center', overflow: 'hidden', overflowY: 'scroll'
        }}>
          <Stack sx={{ gap: '0.5rem', padding: '0.5rem', width: '95%' }}>


            <b>Discography</b>
            <Box sx={{
              border: '1px solid #000', borderRadius: '5px',

              display: 'flex', flexDirection: 'row', gap: '0.5rem',
              width: '95%', margin: 'auto', flexWrap: 'wrap', padding: '1rem 0.5rem', minHeight: '200px',
              boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
              justifyContent: 'center'
            }}>
              {artist?.albums?.length > 0 && artist?.albums?.map((a, i) => {
                return (
                  <Tooltip title={a?.title}>
                    <Stack sx={{
                      width: width >= 600 ? '170px' : '120px',
                      boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                      border: '1px solid #000',
                      borderRadius: '5px', cursor: 'pointer',
                      justifyContent: 'center', padding: '0.25rem', gap: '0.5rem',
                      textAlign: 'center',
                      // flex:1,
                      height: '260px',
                      alignContent: 'center',
                      alignItems: 'center'
                    }}
                      onClick={(e) => {
                        setCurrentAlbum(a)

                      }}
                    >

                      <img src={a?.album_pic[0]} key={i}
                        style={{
                          width: '75px', height: '75px',
                          margin: '0 auto',
                          border: '1px solid #000', borderRadius: '5px',
                          boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)'
                        }}
                        alt={artist?.name + a?.title + 'cover pic'}

                      />
                      <b>{a?.title}</b>
                      <span style={{ fontSize: '0.75rem' }}>{a?.subtitle ? a?.subtitle : <>&nbsp;</>}</span>
                      <span style={{ fontSize: '0.65rem' }}>
                        ( {a?.year} )
                      </span>
                      {a?.status === 'streaming' && <Box sx={{
                        width: '80%',
                        display: 'flex',
                        flexDirection: 'row',
                        margin: '0 auto',
                        flexWrap: 'inline-start',
                      }}>

                        <StreamLinks album={a} size='sml' view='home' />
                      </Box>}
                    </Stack>
                  </Tooltip>
                )
              })}
            </Box>
          </Stack>
        </Container>

        <Container sx={{
          width: '100%',
          display: 'flex', flexDirection: width >= 950 ? 'row' : 'column', gap: '0.5rem', padding: '0.5rem', justifyContent: 'center'
        }}>

          <Container sx={{
            padding: '0.5rem', width: '100%', height: '100%', minHight: '400px',
            color: '#000', overflow: 'hidden',
            backgroundColor: '#FFF', border: '1px solid #000', borderRadius: '5px',
            justifyContent: 'center', overflow: 'hidden', overflowY: 'scroll'
          }}>
            <Stack sx={{ gap: '0.5rem', padding: '0.5rem', width: '95%' }}>

              <b>Video</b>
              <Box sx={{
                border: '1px solid #000', borderRadius: '5px',
                display: 'flex', flexDirection: 'row', gap: '0.5rem',
                width: '95%', margin: 'auto', flexWrap: 'wrap', padding: '0.5rem', minHeight: '200px',
                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)', justifyContent: 'center', alignContent: 'center',
                // maxWidth:'250px'
              }}>
                {artist?.vids?.length > 0 && artist?.vids?.map((v, i) => {
                  return (
                    <Tooltip title={`${v?.song} ${v?.date ? ' (' + v?.date + ')' : ''}`}>
                      <img src={v?.cover_pic} key={i}
                        style={{
                          width: '75px', height: '75px', border: '1px solid #000',
                          boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                          borderRadius: '5px',
                          cursor: 'pointer',
                        }}
                        alt={artist?.name + '-video-' + i < 10 ? '0' : '' + i + '-' + v?.event_name ? v?.event_name : '' + 'cover'}
                        onClick={(e) => {
                          setCurrentVid(v)
                          setZoomType('vid')
                          setZoomModalOpen(true)
                        }}
                      />
                    </Tooltip>
                  )
                })}
              </Box>
              <b>Pics</b>
              <Box sx={{
                border: '1px solid #000', borderRadius: '5px',
                alignContent: 'center',
                display: 'flex', flexDirection: 'row', gap: '0.5rem',
                width: '95%', margin: 'auto', flexWrap: 'wrap', padding: '0.5rem', minHeight: '200px',
                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)', justifyContent: 'center'
              }}>
                {artist?.pics?.length > 0 && artist?.pics?.map((p, i) => {
                  return (<img src={p} key={i}
                    style={{
                      width: '75px', height: '75px',
                      cursor: 'pointer',
                      border: '1px solid #000', borderRadius: '5px',
                      boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)'
                    }}
                    alt={artist?.name + '-pic-' + i < 10 ? '0' : '' + i}
                    onClick={(e) => {
                      setCurrentImg(p)
                      setZoomType('img')
                      setZoomModalOpen(true)
                    }}
                  />)
                })}
              </Box>
            </Stack>
          </Container>
          <ZoomModal
            setZoomModalOpen={setZoomModalOpen}
            zoomModalOpen={zoomModalOpen}
            src={currentImg}
            zoomType={zoomType}
            vid={currentVid}
            handleImgBack={handleImgBack}
            handleImgNext={handleImgNext}
            handleVidNext={handleVidNext}
            handleVidBack={handleVidBack}
          />
        </Container>

        <Events artist={artist} />
        {/* <Container sx={{padding:'0.5rem',width:'100%', height:'100%',minHight:'400px', 
          color:'#000',
            backgroundColor:'#FFF', border: '1px solid #000', borderRadius:'5px',
            justifyContent:'center', overflow:'hidden', overflowY:'scroll'}}>
           <Stack sx={{ gap:'0.5rem', padding:'0.5rem',width:'95%'}}>

              <b>Events</b>
            <Box sx={{border:'1px solid #000', borderRadius:'5px',
              display:'flex', flexDirection: 'row', gap :'0.5rem',
              width:'95%', margin:'auto', flexWrap:'wrap',padding:'0.5rem', minHeight:'200px',
              boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)'
            }}>
              {artist?.shows?.length >0 ? artist?.shows?.map((s,i)=>{
                        return(
                          <Stack>
                            {s?.event_name}
                          </Stack>
                        )
                    }):<Stack sx={{margin:'auto', gap:'0.5rem',textAlign:'center'}}>
                      <span> No Events Listed.</span>
                      <em style={{fontSize:'0.75  rem'}}>( You can change that by heading to booking though! )</em></Stack>}
            </Box>
           </Stack>
          </Container> */}

        <Container sx={{
          padding: '0.5rem', width: '100%', height: '100%', minHight: '400px',
          color: '#000',
          backgroundColor: '#FFF', border: '1px solid #000', borderRadius: '5px',
          justifyContent: 'center', overflow: 'hidden', overflowY: 'scroll'
        }}>
          <Stack sx={{ gap: '0.5rem', padding: '0.5rem', width: '95%' }}>

            <b>Press</b>
            <Box sx={{
              border: '1px solid #000', borderRadius: '5px',
              display: 'flex', flexDirection: 'row', gap: '0.5rem',
              width: '95%', margin: 'auto', flexWrap: 'wrap', padding: '0.5rem', minHeight: '200px',
              boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)'
            }}>
              {artist?.press?.length > 0 ? artist?.press?.map((v, i) => {
                return (<iframe src={v?.url} key={i} style={{ width: '75px', height: '75px', border: '1px solid #000', borderRadius: '5px' }} />)
              }) : <Box sx={{ margin: 'auto', gap: '0.5rem' }}>No Press Listed.</Box>}
            </Box>

          </Stack>
        </Container>

        {/* </Paper> */}
      </Stack>
    </Container>
  )
}

export default EPK